<div *ngIf="infectedFiles?.length"
     class="infected-files-section mat-small">
  <p>
    The following file(s) has been deleted because of malware found in it. Please click
    <a class="refresh-link refresh-link-inline"
       href="#"
       (click)="onRefreshClick($event)">
      REFRESH
    </a>
    to update the list of files
  </p>
  <ul>
    <li *ngFor="let file of infectedFiles"
        class="infected-file infected-file-item">
      {{ file }}
    </li>
  </ul>
</div>
